// Server rate limits for internal GraphQL reads (per minute):
//   - Logged-in: 400 requests/minute
//   - Anonymous: 60 requests/minute
// Each navigation fires ~3-5 GraphQL requests, so we apply a 80% safety margin.
export const NAV_RATE_WINDOW_MS = 60_000
export const NAV_RATE_LIMIT_LOGGED_IN = 64 // (400 / 5) * 0.8
export const NAV_RATE_LIMIT_ANON = 10 // (60 / 5) * 0.8

// Minimum ms between navigations to avoid secondary (burst) rate limits
export const NAV_THROTTLE_MS = 150

const navTimestamps: number[] = []
const visitedIndices = new Set<number>()
let lastNavTime = 0
let pendingNavIndex: number | null = null

function evictExpired() {
  const cutoff = Date.now() - NAV_RATE_WINDOW_MS
  while (navTimestamps.length > 0 && navTimestamps[0]! < cutoff) {
    navTimestamps.shift()
  }
}

export function isThrottled(): boolean {
  return Date.now() - lastNavTime < NAV_THROTTLE_MS
}

export function hasHitNavRateLimit(loggedIn: boolean): boolean {
  evictExpired()
  const limit = loggedIn ? NAV_RATE_LIMIT_LOGGED_IN : NAV_RATE_LIMIT_ANON
  return navTimestamps.length >= limit
}

export function recordNavigation() {
  evictExpired()
  navTimestamps.push(Date.now())
  lastNavTime = Date.now()
}

export function markVisited(index: number) {
  visitedIndices.add(index)
}

export function isVisited(index: number): boolean {
  return visitedIndices.has(index)
}

export function setPendingNavIndex(index: number) {
  pendingNavIndex = index
}

export function consumePendingNavIndex(): number | null {
  const idx = pendingNavIndex
  pendingNavIndex = null
  return idx
}

export function resetNavRateLimit() {
  navTimestamps.length = 0
  visitedIndices.clear()
  lastNavTime = 0
  pendingNavIndex = null
}
